var Item;
(function (Item) {
    Item["outOfStock"] = "out-of-stock";
    Item["maxSelectableReached"] = "max-selectable-reached";
})(Item || (Item = {}));

export { Item };
//# sourceMappingURL=item.enum.js.map
